/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */
import React, {useEffect, useState} from "react";
import dayjs from "dayjs";

import styled from "styled-components";

import { sortBy } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faSearch } from "@fortawesome/pro-solid-svg-icons";
import { faPenToSquare, faXmark } from "@fortawesome/free-solid-svg-icons";
import { APP_COLORS } from "../../common/Constants";

import isToday from 'dayjs/plugin/isToday';
import isYesterday from 'dayjs/plugin/isYesterday';
import {getChatMessages, getConversations, submitChatMessage} from "./chatMessagesSlice";

dayjs.extend(isToday);
dayjs.extend(isYesterday);
dayjs.extend(isYesterday);

const ChatHistoryContainer = (props) => {
    const {
        currentConversationId,
        conversations,
        handleConversationSelect,
        handleNewChat,
        HandleSearchChatHistory,
    } = props;

    const [conversationGroup, setConversationGroup] = useState(null);
    const [enableSearch, setEnableSearch] = useState(false);
    const [searchCriteria, setSearchCriteria] = useState('');

    useEffect(() => {
        const today = dayjs();
        const previous30days = dayjs(today).subtract(30, 'days');
        let groups = sortBy(conversations, ['updated']).reverse().reduce((group, item) => {
            let proceedOn = true;
            if (searchCriteria && searchCriteria.length > 0 && !item.name.toLowerCase().includes(searchCriteria.toLowerCase())) {
                console.log(`${searchCriteria} - ${item.name} - ${item.name.includes(searchCriteria)}`)
                proceedOn = false;
            }

            if (proceedOn) {
                let date = dayjs(item.updated).format('YYYY-MM-DD');

                const diffDay = dayjs(today).diff(date, 'day');

                let groupName = 'Older';
                if (dayjs(date).isToday()) {
                    groupName = 'Today';
                } else if (dayjs(date).isYesterday()) {
                    groupName = 'Yesterday';
                } else if (diffDay >= 2 && diffDay <= 7) {
                    groupName = 'Last Week';
                } else if (diffDay > 7 && diffDay <= 30) {
                    groupName = 'Last Month';
                } else if (diffDay > 30) {
                    groupName = 'Older';
                }
                if (!group[groupName]) {
                    group[groupName] = [];
                }
                group[groupName].push(item);
            }
            return group;
        }, {});

        setConversationGroup(groups);
    }, [conversations, searchCriteria]);

    const handleCloseSearch = async () => {
       setSearchCriteria('');
       setEnableSearch(false);
    };

    return (
        <Container>
            <ChatHistoryTool>
                <SearchContent>
                    <SearchInputBox>
                        {/*{ enableSearch && (*/}
                            <input
                              type='text'
                              className="form-control"
                              style={{ width: '100%', fontSize: 13, height: 30, paddingLeft: 6 }}
                              // placeholder="Search..."
                              placeholder={'Find...'}
                              value={searchCriteria}
                             // onKeyDown={handleOnKeyDown}
                              onChange={(e) => {
                                  setSearchCriteria(e.target.value)
                              }}
                            />
                        {/*)}*/}
                    </SearchInputBox>
                  {/*<div style={{ justifySelf: 'end' }}>*/}
                  {/*  { enableSearch ? (*/}
                  {/*    <FontAwesomeIcon*/}
                  {/*      color={APP_COLORS['blue']}*/}
                  {/*      icon={faXmark}*/}
                  {/*      onClick={() => handleCloseSearch()}*/}
                  {/*      style={{ fontSize: '22px', cursor: 'pointer', marginTop: 4 }}*/}
                  {/*      onMouseEnter={(e) => {*/}
                  {/*          e.currentTarget.style.color = APP_COLORS['orange'];*/}
                  {/*      }}*/}
                  {/*      onMouseLeave={(e) => {*/}
                  {/*          e.currentTarget.style.color = APP_COLORS['blue'];*/}
                  {/*      }}*/}
                  {/*    />*/}
                  {/*  ) : (*/}
                  {/*    <FontAwesomeIcon*/}
                  {/*      color={APP_COLORS['blue']}*/}
                  {/*      icon={faSearch}*/}
                  {/*      onClick={() => setEnableSearch(true)}*/}
                  {/*      style={{ fontSize: '18px', cursor: 'pointer' }}*/}
                  {/*      onMouseEnter={(e) => {*/}
                  {/*        e.currentTarget.style.color = APP_COLORS['orange'];*/}
                  {/*      }}*/}
                  {/*      onMouseLeave={(e) => {*/}
                  {/*        e.currentTarget.style.color = APP_COLORS['blue'];*/}
                  {/*      }}*/}
                  {/*    />*/}
                  {/*  )}*/}
                  {/*</div>*/}
                </SearchContent>
                <div style={{ justifySelf: 'center' }}>
                    <FontAwesomeIcon
                        color={APP_COLORS['blue']}
                        icon={faPenToSquare}
                        onClick={() => handleNewChat()}
                        style={{
                            fontSize: '18px',
                            cursor: 'pointer'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.color = APP_COLORS['orange'];
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.color = APP_COLORS['blue'];
                        }}
                    />
                </div>
            </ChatHistoryTool>
            <Header>Conversations</Header>
            <ChatsHistoryContainer>
                {conversations && conversations.length > 0 ? (
                    <>
                        {conversationGroup && Object.keys(conversationGroup).map((key, index) => (
                            <ConversationItem
                                key={'conversation-group' + index}
                                groupName={key}
                                conversations={conversationGroup[key]}
                                handleConversationSelect={handleConversationSelect}
                                currentConversationId={currentConversationId}
                            />
                        ))}
                    </>
                ) : (
                    <div className="text-muted">No conversations yet</div>
                )}
            </ChatsHistoryContainer>
        </Container>
    )
}

export default ChatHistoryContainer;

const ConversationItem = (props) => {
    const {
        groupName,
        currentConversationId,
        conversations,
        handleConversationSelect
    } = props;

    return (
        <ConversationItemContainer>
            <ConversationItemHeader>{groupName}</ConversationItemHeader>
            {conversations?.map((conversation, index) => (
                <ConversationItemContent
                    key={conversation.id + '-' + index}
                    onClick={() => handleConversationSelect(conversation.id)}
                    style={{
                        backgroundColor: currentConversationId === conversation.id ? APP_COLORS['gray-200'] : 'transparent'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = APP_COLORS['gray-200'];
                    }}
                    onMouseLeave={(e) => {
                        if (currentConversationId !== conversation.id) {
                            e.currentTarget.style.backgroundColor = 'transparent';
                        }
                    }}
                >
                  {conversation.name}
                </ConversationItemContent>
            ))}
        </ConversationItemContainer>
    )
}

const Container = styled.div `
    
`;

const ChatHistoryTool = styled.div `
    display: grid;
    grid-template-columns: 1fr 35px;
    
    padding: 5px;
    
    height: 40px;
    
    align-items: center;
`;

const Header = styled.div `
    padding: 5px;
    border-bottom: 2px solid ${APP_COLORS['tech-blue']};

    font-size: 18px;
    font-weight: 600;
    color: ${APP_COLORS['tech-blue']};
`;

const ChatsHistoryContainer = styled.div `
    padding: 5px;

    height: calc(100vh - 160px);
    overflow-x: auto;
`;

const ConversationItemContainer = styled.div `
    margin-bottom: 20px;
    margin-left: 5px;
`;

const ConversationItemHeader = styled.div `
    font-size: 16px;
    font-weight: 600;
    color: ${APP_COLORS['tech-blue']};
`;

const ConversationItemContent = styled.div `
    font-size: 0.875rem;
    margin-top: 5px;
    padding: 5px 10px;
  
    border-radius: 4px;
  
    color: ${APP_COLORS['gray-600']};
    background-color: transparent;
    
    cursor: pointer;
  
    align-content: center;

    transition: background-color 0.2s ease;
`;

const SearchContent = styled.div `
    display: grid;
    grid-template-columns: 1fr  20px;
  
    align-items: center;
    justify-items: center;
`;

const SearchInputBox = styled.div `
    width: 100%;
`;
